
import { CreditorStatusTypes } from "./CreditorStatusTypes";

export const MAIN_SEARCH_DEFAULT_FILTERS = {
    isOpenCase: true,
    isNextDueDateCase: true,
    isCloseCase: true,
    isCourtCase: true,
    isSentenceCase: true,
    caseNumber: "",
    invoiceNumber: "",
    mainAmount: "",
    balance: "",
    debtorNameNo: "",
    birthdate: "",
    creditorNameNo: "",
    phone: "",
    address: "",
    lastMsgActivityName: "",
    creditorStatus: CreditorStatusTypes.ACTIVE,
    creditorGroupIdName: "",
    custId: "",
    arNo: "",
  }